module.exports = __webpack_public_path__ + "static/who-we-help-college-faeb9f92488583a2105a6971372a8f7b.jpg";